export class ServerError extends Error {
  constructor(e = null) {
    if (e && e.response && e.response.data) {
      switch (e.response.data.code) {
        case 'FileFormatException':
          super('File format CSV Error');
          return;
        case 'ProvisionedThroughputExceededException':
          super('Throughput Error');
          return;
      }
    }
    super('Internal Server Error');
  }
}

export class AuthenticationError extends Error {
  constructor() {
    super('Not authenticated.');
  }
}

export class AuthorizationError extends Error {
  constructor() {
    super('Not authorized.');
  }
}

export class LargePayloadError extends Error {
  constructor() {
    super('Payload Too Large.');
  }
}
